import { required } from "vuelidate/lib/validators";

export default class FaturamentoData {
  valor = null;
  desconto = null;
  conta = null;
  plano_conta = null;
  vencimento = null;
  subtotal = 0;
  pagamentos = [];
  constructor(
    valor = 0,
    conta = null,
    plano_conta = null,
    desconto = null,
    vencimento = null,
    subtotal = 0,
    pagamentos = []
  ) {
    this.valor = valor;
    this.conta = conta;
    this.plano_conta = plano_conta;
    this.vencimento = vencimento;
    this.subtotal = subtotal;
    this.pagamentos = pagamentos;
    this.desconto = desconto;
  }
}

export const FaturamentoDataRequired = {
  pagamentos: {
    required,
  },
};
